var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "n-accordion-chart-header",
      class: !_vm.isRtl && "order-change",
      style: "background-color: " + _vm.bgColor + "; color: " + _vm.textColor,
      on: {
        click: function($event) {
          _vm.selected = !_vm.selected
        }
      }
    },
    [
      !_vm.isRtl
        ? [
            _c(
              "div",
              { staticClass: "header--left small-12 medium-6 large-6" },
              [
                _c("div", {
                  staticClass: "color-bar",
                  class: _vm.isChild && "color-bar--small",
                  style:
                    "background-color: " +
                    _vm.barColor +
                    "; width: " +
                    _vm.barWidth +
                    "%"
                }),
                _c(
                  "div",
                  { staticClass: "text-percent", style: _vm.textPercentStyle },
                  [_vm._v(_vm._s(_vm.formatPercent(_vm.percent)))]
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "header--right small-12 medium-6 large-6" },
              [
                _c("div", { staticClass: "text-label" }, [
                  _c("div", { staticClass: "spv-info-wrapper info-trend" }, [
                    _vm._v(
                      _vm._s(_vm.label) +
                        " " +
                        _vm._s(
                          _vm.value
                            ? "(" + _vm.formatMoney(_vm.value) + ")"
                            : ""
                        )
                    ),
                    _vm.infoText
                      ? _c(
                          "div",
                          {
                            staticClass: "info-overlay",
                            class: !_vm.openTooltip && "hide"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "info-overlay__icon",
                                class: _vm.selected && "header-info",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return (function() {})($event)
                                  },
                                  mouseover: function($event) {
                                    _vm.openTooltip = true
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fo icon-info_kreis" })]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "info-overlay__text",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    _vm.openTooltip = false
                                  }
                                }
                              },
                              [
                                _c("span", [_vm._v(_vm._s(_vm.infoText))]),
                                _c("i", {
                                  staticClass: "fo icon-verzichten_x_kreis"
                                })
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ])
              ]
            )
          ]
        : [
            _c(
              "div",
              { staticClass: "header--left small-12 medium-6 large-6" },
              [
                _c("div", { staticClass: "text-label" }, [
                  _vm._v(
                    _vm._s(_vm.label) +
                      " " +
                      _vm._s(
                        _vm.value ? "(" + _vm.formatMoney(_vm.value) + ")" : ""
                      )
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "text-percent", style: _vm.textPercentStyle },
                  [_vm._v(_vm._s(_vm.formatPercent(_vm.percent)))]
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "header--right small-12 medium-6 large-6" },
              [
                _c("div", {
                  staticClass: "color-bar",
                  class: _vm.isChild && "color-bar--small",
                  style:
                    "background-color: " +
                    _vm.barColor +
                    "; width: " +
                    _vm.barWidth +
                    "%"
                })
              ]
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75452078", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75452078","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/n-accordion-chart-header.vue
// module id = MU7I
// module chunks = 0